export default __webpack_public_path__ + "ae8f8591cf3e12799d7b3331aab5ae99.webp";